
// fetch api constants
export const HOST_PREFIX = 'https://';
export const HOST_SUFFIX = '.damefeedback.com/';
// export const CONFIGS_URL = 'configs';
export const CONFIGS_URL = 'https://akcelita-artsense.s3.amazonaws.com/damefeedback/configs';
